import { Quote } from "lucide-react";
import { BUSINESS, FOUNDER } from "#/lib/constants";
import { SectionLabel } from "#/components/shared/SectionLabel";
import { CTAButton } from "#/components/shared/CTAButton";
import { useScrollAnimation } from "#/hooks/useScrollAnimation";

/**
 * A personal note from the owner. Deliberately the last thing before the
 * estimate form: the page argues "family owned, owner on every job", and this
 * is the one place that claim is made in his own voice.
 */
export function AboutFounder() {
  const { ref, isVisible } = useScrollAnimation(0.05);

  return (
    <section className="bg-light-bg py-20 lg:py-28">
      <div ref={ref} className="mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <div className="flex justify-center">
          <SectionLabel>A Personal Note</SectionLabel>
        </div>

        <Quote
          aria-hidden="true"
          className="mx-auto mt-8 h-12 w-12 text-flame/25"
        />

        <blockquote
          className={`mt-6 font-heading text-xl font-medium leading-relaxed text-graphite transition-all duration-700 sm:text-2xl lg:text-[1.75rem] lg:leading-[1.45] ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
          }`}
        >
          "{FOUNDER.quote}"
        </blockquote>

        <div className="mt-10 flex flex-col items-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-graphite font-heading text-lg font-bold text-white">
            {FOUNDER.name.charAt(0)}
          </span>
          <p className="mt-4 font-heading text-lg font-bold text-graphite">
            {FOUNDER.name}
          </p>
          <p className="text-sm text-concrete-dark">
            {FOUNDER.role}, {BUSINESS.name}
          </p>
        </div>

        <div className="mt-12">
          <CTAButton
            href={BUSINESS.phoneHref}
            variant="flame"
            size="lg"
            className="rounded-none uppercase tracking-wide"
          >
            Talk to Nick: {BUSINESS.phone}
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
